const includedtestlist = [
  {
    testname: "Complete Blood Count (CBC)",
    img: "/Pathology/bloodcnt.png",
    info: "complete blood count info",
  },
  {
    testname: "Thyroid Profile (T3, T4, UTSH)/TFT",
    img: "/Pathology/Haemoglobin.png",
    info: "Hemoglobin (Hb) measurement is a standard test among pregnant women that is used to evaluate physical status, Measure hemoglobin protein (Iron Level) and anemia.",
  },
  {
    testname: "Urine Routine Test",
    info: "Rubella IgM Test",
    img: "/Pathology/Haemoglobin.png",
  },
  {
    testname: "Random Blood Sugar",
    info: "Hepatitis",
    img: "/Pathology/Haemoglobin.png",
  },
  {
    testname: "Iron Profile Test",
    info: "Syphilis Test",
    img: "/Pathology/Haemoglobin.png",
  },
  // {
  //   testname: "HIV Test",
  //   info: "HIV Test",
  //   img: "/Pathology/Haemoglobin.png",
  // },
  // {
  //   testname: "Urine Test(for sugar and protein)",
  //   img: "/Pathology/urine-test.png",
  //   info: "urine test info",
  // },
  // {
  //   testname: "Glucose Screening Test or GTT",
  //   info: " Glucose Screening Test or GTT",
  //   img: "/Pathology/Haemoglobin.png",
  // },
  // {
  //   testname: "HB Test",
  //   info: "HB Test",
  //   img: "/Pathology/Haemoglobin.png",
  // },
];

const includedtestlist1 = [
  {
    testname: "Quadruple Screen Test",
    info: "HB Test",
    img: "/Pathology/Haemoglobin.png",
  },
  // {
  //   testname: "Glucose screening Test or GTT",
  //   info: "Glucose screening Test or GTT",
  //   img: "/Pathology/Haemoglobin.png",
  // },
  // {
  //   testname: "Complete Blood Count (CBC) Test",
  //   img: "/Pathology/bloodcnt.png",
  //   info: "complete blood count info",
  // },
  // {
  //   testname: "Urine Test(for sugar and protein)",
  //   img: "/Pathology/urine-test.png",
  //   info: "urine test info",
  // },
];
const includedtestlist2 = [
  {
    testname: "OGCT/ OGTT",
    img: "/Pathology/urine-test.png",
    info: "Quadruple screen test",
  },
];
const includedtestlist3 = [
  {
    testname: "Hepatitis B (Rapid)",
    img: "/Pathology/urine-test.png",
    info: "HB TEST",
  },
  {
    testname: "Hepatitis C (Rapid)",
    img: "/Pathology/urine-test.png",
    info: "Glucose screening test",
  },
  {
    testname: " Complete Blood Count (CBC)",
    img: "/Pathology/urine-test.png",
    info: "Complete Blood Count (CBC) test",
  },
  {
    testname: "HIV (AIDS)",
    img: "/Pathology/urine-test.png",
    info: "urine test info",
  },
  {
    testname: "Urine Routine Test",
    img: "/Pathology/urine-test.png",
    info: "urine test info",
  },
  {
    testname: "Thyroid Profile (T3, T4, UTSH)/TFT",
    img: "/Pathology/urine-test.png",
    info: "urine test info",
  },
  {
    testname: "Iron Profile Test",
    img: "/Pathology/urine-test.png",
    info: "urine test info",
  },
  {
    testname: "Random Blood Sugar",
    img: "/Pathology/urine-test.png",
    info: "urine test info",
  },
  {
    testname: "OGCT/ OGTT (24-28 weeks)",
    img: "/Pathology/urine-test.png",
    info: "urine test info",
  },
  {
    testname: "LFT",
    img: "/Pathology/urine-test.png",
    info: "urine test info",
  },
];
const includedtestlist4 = [
  {
    testname: "Hb HPLC",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "Random Blood Sugar",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "Blood Grouping and Rh Factor",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "Hepatitis B (Rapid)",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "Hepatitis C (Rapid)",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "Complete Blood Count (CBC)",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "HIV (AIDS)",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "Syphylis",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "Urine Routine Test",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "Rubella Viral Antigen (IgG)",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "ICT ( Indirect Coombs Test)",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "Folic Acid",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "Vitamin D & B12 Test",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "HbA1c Test",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "Thyroid Profile (T3, T4, UTSH)/TFT",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "Iron Profile Test",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
  {
    testname: "OGCT/ OGTT",
    img: "/Pathology/urine-test.png",
    info: "Group B Streptococcus (GBS) Test",
  },
];
export {
  includedtestlist,
  includedtestlist1,
  includedtestlist2,
  includedtestlist3,
  includedtestlist4,
};
